import { WEEK_DAYS } from 'constants/forecast';

export const formatForecastName = (name) => {
  if (!name) return '';

  // Remove the week day from the end of the name only if it's a standalone word (preceded by a space).
  // Case-insensitive: matches mon, MON, Mon, MoN, etc.
  for (const day of WEEK_DAYS) {
    const re = new RegExp(`\\s+${day}$`, 'i');
    if (re.test(name)) {
      return name.replace(re, '').trim();
    }
  }

  return name;
};
